<template>
  <div class="w-full pt-8 px-8 pb-4 flex flex-col justify-center">
    <div class="flex justify-between w-full mb-4">
      <h3 class="text-cw-900 font-montserrat mt-auto">Our Schools</h3>
      <div class="w-1/3">
        <InputDropdownSelector
          :type="'SCHOOLS'"
          :modal-action="'showModalNested'"
        />
      </div>
    </div>

    <div class="flex items-start justify-between w-full">
      <h5 class="text-cw-300">
        All of the CareerWise schools collaborating across the country.
      </h5>
    </div>
    <div v-if="loaded">
      <div
        v-if="schools.length"
        class="grid grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12 mt-12 max-h-96 overflow-y-scroll"
      >
        <div
          v-for="(item, i) in schools"
          :key="i"
          class="flex flex-col items-center justify-center"
        >
          <img class="max-h-20" :src="item.logo" alt="School Logo" />
          <p
            class="mt-4 text-truegray-500 font-thin text-center text-sm underline"
          >
            {{ item.profile_title }}
          </p>
        </div>
      </div>
      <div v-else class="w-full mt-8">
        <p class="text-sm">No schools found in this region.</p>
      </div>
    </div>
    <div v-else class="w-full flex items-center justify-center">
      <div class="w-24 h-24 flex items-center justify-center mt-12">
        <lottie :options="loadingAnimationOptions" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref, onMounted } from 'vue'
import { useStore } from '../../../../js/store/index.js'
import InputDropdownSelector from '../InputDropdownSelector.vue'
import * as loadingAnimation from '../../../../shared/components/loading-dark.json'

export default defineComponent({
  name: 'ModalSchoolsList',

  components: {
    InputDropdownSelector,
  },

  setup() {
    const store = useStore()

    const loadingAnimationOptions = { animationData: loadingAnimation.default }
    const loaded = ref(false)

    const schools = computed(() => {
      return store.getters['contributors/getSchools']
    })

    onMounted(async () => {
      // reset region filter
      loaded.value = false
      await store.dispatch('contributors/dispatchUpdateStatsSchools')
      loaded.value = true
    })

    return {
      loadingAnimationOptions,
      loaded,
      schools,
    }
  },
})
</script>
